// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dynamic modal height based on content - hide scrollbar */
.custom-modal::part(body) {
  overflow: hidden !important;
  overflow-y: hidden !important;
}

.custom-modal::part(content) {
  overflow: hidden !important;
}`, "",{"version":3,"sources":["webpack://./src/Components/Model/Model.css"],"names":[],"mappings":"AAAA,2DAA2D;AAC3D;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":["/* Dynamic modal height based on content - hide scrollbar */\n.custom-modal::part(body) {\n  overflow: hidden !important;\n  overflow-y: hidden !important;\n}\n\n.custom-modal::part(content) {\n  overflow: hidden !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
